import {useEffect, useState} from 'react';

import {TOP_NAV_HEIGHT} from '../constants';

export function useNavbarBottom() {
  const [navbarBottom, setNavbarBottom] = useState(
    Math.max(0, TOP_NAV_HEIGHT - window.scrollY)
  );

  useEffect(() => {
    const update = () => {
      setNavbarBottom(Math.max(0, TOP_NAV_HEIGHT - window.scrollY));
    };

    document.addEventListener('scroll', update, {capture: true, passive: true});
    window.addEventListener('resize', update, {passive: true});
    return () => {
      document.removeEventListener('scroll', update, {capture: true});
      window.removeEventListener('resize', update);
    };
  }, []);

  return navbarBottom;
}
